import { InputMaskProcessingBase } from '../input-mask-processing.base';

export class ZipMaskProcessing extends InputMaskProcessingBase {
  protected allowedChars = '0123456789';
  protected maxLength = 5;
}
